import axios, { AxiosRequestConfig } from 'axios'
import { CreateOrderRequestDto, CreateOrderResponseDto } from '@sparling/financial-common'

export const createOrder = async (
  { token, ...data }: CreateOrderRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateOrderResponseDto> => {
  const response = await axios.post(`${process.env.REACT_APP_REST_API_URL}/trading/orders`, data, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.data
}
